export const INPUT_TEXT = "INPUT_TEXT";
export const REQUEST_API_PENDING = "REQUEST_API_PENDING";
export const REQUEST_API_SUCCESS = "REQUEST_API_SUCCESS";
export const REQUEST_API_FAILED = "REQUEST_API_FAILED";
